import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import {
  createSearchParams,
  useParams,
  useSearchParams,
} from 'react-router-dom'

import { deleteRequest, getRequest } from '../../../services/base'
import Pagination from '../../../components/common/Pagination'
import NoRecordsFound from '../../../components/common/NoRecordsFound'
import Button from '../../common/Button'
import {
  InSpectionPointsContext,
  SET_INSPECTION_POINTS_DATA,
} from './context/context'
import InSpectionPointsRow from './InSpectionPointsRow'
import GenerateWiresButton from '../../generate_wires_button'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const InSpectionPoints = (props) => {
  let { vehicle } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const [state, dispatch] = useContext(InSpectionPointsContext)
  const [navState, navDispatch] = useContext(NavContext)

  const currentUrl = useRef(`/api/inspection_points/?vehicle=${vehicle}`)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Inspection Points`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    getInSpectionPointsData()
  }, [])

  const getInSpectionPointsData = async () => {
    let res = await getRequest(currentUrl.current)
    dispatch({ type: SET_INSPECTION_POINTS_DATA, data: res })
  }

  const deleteInSpectionPoints = async (id) => {
    if (
      window.confirm(
        'Are you sure? You will delete selected Inspection Points'
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Inspection Points',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(
        `/api/inspection_points/${id}/?vehicle=${vehicle}`
      )
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Inspection Points successfully deleted',
        },
      })
      getInSpectionPointsData()
    }
  }

  return (
    <div className="pt-3 w-full">
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        action={`/vehicles/${vehicle}/inspection_points`}
        acceptCharset="UTF-8"
        method="get"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex space-x-5 justify-between">
          <div className="w-1/2 flex justify-between space-x-2">
            <div className="w-full">
              <input
                autoComplete="off"
                className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none"
                placeholder="Enter Connector's Name"
                type="search"
                name="search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value)
                }}
              />
            </div>
            <Button
              className={`bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded`}
              onClick={() => {
                currentUrl.current = `/api/inspection_points/?vehicle=${vehicle}&search=${searchQuery}`
                getInSpectionPointsData()
              }}
              text="Search"
            >
              Search
            </Button>
          </div>

          <div className="">
            <GenerateWiresButton is_inspection_points_wire={true} />
          </div>
        </div>
      </form>
      <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
        <div className="w-3/12 px-2">CONNECTOR</div>
        <div className="w-5/12 px-2">INSPECTION POINT ID</div>
        <div className="w-3/12 px-2">Harness</div>
        <div className="w-1/12 px-2 text-right"></div>
      </div>
      {state?.data?.results?.map((inspection_point, index) => {
        return (
          <InSpectionPointsRow
            {...inspection_point}
            onDelete={() => {
              deleteInSpectionPoints(inspection_point.id)
            }}
            key={`inspection-point-${index}`}
            deleteInSpectionPoints={() => {
              deleteInSpectionPoints(inspection_point.id)
            }}
          />
        )
      })}

      {state?.data?.results?.length < 1 && (
        <NoRecordsFound
          caption={'Inspection Points not found'}
          loading={false}
        />
      )}
      {state?.data?.pagination && (
        <div className="py-6">
          <Pagination
            context={state?.data?.pagination}
            onClickNext={(e) => {
              currentUrl.current = e
              getInSpectionPointsData()
            }}
            onClickPrev={(e) => {
              currentUrl.current = e
              getInSpectionPointsData()
            }}
          />
        </div>
      )}
    </div>
  )
}

export default InSpectionPoints
